module.exports = __webpack_public_path__ + "front/img/bottom_bg.9b3f485b.png";